<template>
  <div class="modal fade" id="ModalManageAccessUser" tabindex="99" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">مدیریت سطوح دسترسی <b>( {{ UserData.SUserName }} )</b></p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2" style="height: 70vh; overflow-y: auto;">
          <!-- نمایش دسترسی های سطح اصلی -->
          <div class="row" v-for="row in getTbObjectsForShow(getNSystemID)" :key="row.NObjectId">
            <div class="col p-0">
              <div class="card my-2">
                <h6 class="card-title py-2 m-0" style="background-color: rgb(230 242 253);">{{ row.SObjectName_Fa }}</h6>
                <hr class="m-0 mb-2">
                <div class="card-body py-0">
                  <table class="w-100 mb-2">
                    <!-- نمایش دسترسی های زیر مجموعه -->
                    <tr v-for="subMenu in getTbObjectsForShow(row.NObjectId)" :key="subMenu.NObjectId">
                      <td class="text-left pl-1 pt-1" style="width: 20px;">
                        <input type="checkbox" :checked="checkResourceAccessUser(subMenu.NObjectId)"
                          v-on:click="addRemoveResourceAccessUser($event, subMenu.NObjectId)" />
                      </td>
                      <td class="text-right" style="font-size: 0.85rem; font-weight: 300;">
                        {{ subMenu.SObjectName_Fa }}
                      </td>
                      <td class="" style="width: 90px;">
                        <div class="row">
                          <div class="col p-0 m-0">
                            <!-- دسترسی ذخیره اطلاعات -->
                            <a v-if="checkResourceAccessUser(subMenu.NObjectId) == true" title="دسترسی ذخیره اطلاعات"
                              v-on:click="changeResourceAccessUserAddDeletePrint(subMenu.NObjectId, 'BIsAddNew')">
                              <i class="far fa-save fa-lg"
                                :style="checkResourceAccessUserAddDeletePrint(subMenu.NObjectId, 'BIsAddNew') == true ? 'color: #28a745;' : 'color: #d5d5d5 ;'"></i>
                            </a>
                            <i v-else class="far fa-save fa-lg" style="color: #d5d5d5;"></i>
                          </div>
                          <div class="col p-0 m-0">
                            <!-- دسترسی حذف اطلاعات -->
                            <a v-if="checkResourceAccessUser(subMenu.NObjectId) == true" title="دسترسی حذف اطلاعات"
                              v-on:click="changeResourceAccessUserAddDeletePrint(subMenu.NObjectId, 'BIsDelete')">
                              <i class="far fa-trash-alt fa-lg"
                                :style="checkResourceAccessUserAddDeletePrint(subMenu.NObjectId, 'BIsDelete') == true ? 'color: #ff3547;' : 'color: #d5d5d5 ;'"></i>
                            </a>
                            <i v-else class="far fa-trash-alt fa-lg" style="color: #d5d5d5;"></i>
                          </div>
                          <div class="col p-0 m-0">
                            <!-- دسترسی چاپ اطلاعات -->
                            <a v-if="checkResourceAccessUser(subMenu.NObjectId) == true" title="دسترسی چاپ اطلاعات"
                              v-on:click="changeResourceAccessUserAddDeletePrint(subMenu.NObjectId, 'BIsReport')">
                              <i class="fas fa-print fa-lg"
                                :style="checkResourceAccessUserAddDeletePrint(subMenu.NObjectId, 'BIsReport') == true ? 'color: #4285f4;' : 'color: #d5d5d5 ;'"></i>
                            </a>
                            <i v-else class="fas fa-print fa-lg" style="color: #d5d5d5;"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!--Footer-->
        <div class="modal-footer flex-center px-4">
          <a class="btn btn-info waves-effect waves-light" v-bind:class="checkConnectToServer ? 'disabled btn-pink' : ''"
            v-on:click="SaveEditResourceAccessUser()">
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            ذخیره تغییرات
          </a>
          <a class="btn btn-outline-info waves-effect waves-light" v-bind:class="checkConnectToServer ? 'disabled' : ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem" data-dismiss="modal">انصراف</a>
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // لیست محلی تمام سطوح دسترسی نرم افزار
      TbResourceList: [],
      // لیست محلی دسترسی های کاربر
      LocalResourceAccessUser: [],
      // کنترل وضعیت اتصال به سرور
      checkConnectToServer: false,
    };
  },
  props: ["ResourceAccessUser", "UserData"],
  created() {
    this.getTbObjects();
  },
  computed: {
    // کنترل سطح دسترسی کاربر
    checkResourceAccessUser() {
      return function (NObjectId) {
        // آیا سطح دسترسی مورد نظر در لیست دسترسی های کاربر وجود دارد ؟
        let index = this.LocalResourceAccessUser.findIndex(function (item) {
          return item.NObjectId == NObjectId
        });
        if (index != -1) {
          return true;
        } else {
          return false;
        }
      }
    },
    // کنترل دسترسی به جدید ، حذف و چاپ
    checkResourceAccessUserAddDeletePrint() {
      return function (NObjectId, Action) {
        // آیا سطح دسترسی مورد نظر در لیست دسترسی های کاربر وجود دارد ؟
        let index = this.LocalResourceAccessUser.findIndex(function (item) {
          return item.NObjectId == NObjectId
        });
        if (index != -1) {
          if (Action == 'BIsAddNew' && this.LocalResourceAccessUser[index].BIsAddNew == true)
            return true;
          else if (Action == 'BIsDelete' && this.LocalResourceAccessUser[index].BIsDelete == true)
            return true;
          else if (Action == 'BIsReport' && this.LocalResourceAccessUser[index].BIsReport == true)
            return true;
          else
            return false;
        } else {
          return false;
        }
      }
    },
    // استخراج کد سیستم حسابداری
    getNSystemID() {
      return this.$store.getters.getNSystemID;
    }
  },
  methods: {
    // دریافت لیست تمام سطوح دسترسی نرم افزار از مخزن اصلی
    async getTbObjects() {
      this.TbResourceList = await this.$store.getters.getTbObjects;
    },

    // فیلتر لیست محلی تمام سطوح دسترسی جهت نمایش
    getTbObjectsForShow(NObjectId) {
      // استخراج کد سیستم حسابداری
      let NSystemID = this.getNSystemID;
      // اگر آبجکت آیدی مخالف کد سیستم حسابداری بود
      if (NObjectId != NSystemID) {
        // انتخاب سایر سطوح بر اساس سطر انتخاب شده
        let listTemp = this.TbResourceList.filter(function (item) {
          return item.NObjectParentId == NObjectId
        });
        return listTemp;
      } else {
        // انتخاب سطح اصلی
        let listTemp = this.TbResourceList.filter(function (item) {
          return item.NObjectParentId == NSystemID
        });
        return listTemp;
      }
    },
    // افزودن سطح دسترسی جدید
    addRemoveResourceAccessUser(event, NObjectId) {
      if (event.target.checked) {
        //  افزودن سطح دسترسی به لیست دسترسی های کاربر
        this.LocalResourceAccessUser.push({
          NUserCode: this.UserData.NUserCode,
          NObjectId: NObjectId,
          BIsAddNew: false,
          BIsDelete: false,
          BIsReport: false
        });
      } else {
        // حذف سطح دسترسی از لیست دسترسی های کاربر
        this.LocalResourceAccessUser = this.LocalResourceAccessUser.filter(function (item) {
          return item.NObjectId != NObjectId
        });
      }
    },
    // تغییر سطح دسترسی به جدید ، حذف و چاپ
    changeResourceAccessUserAddDeletePrint(NObjectId, Action) {
      // آیا سطح دسترسی مورد نظر در لیست دسترسی های کاربر وجود دارد ؟
      let index = this.LocalResourceAccessUser.findIndex(function (item) {
        return item.NObjectId == NObjectId
      });
      if (index != -1) {
        if (Action == 'BIsAddNew')
          this.LocalResourceAccessUser[index].BIsAddNew = !this.LocalResourceAccessUser[index].BIsAddNew;
        else if (Action == 'BIsDelete')
          this.LocalResourceAccessUser[index].BIsDelete = !this.LocalResourceAccessUser[index].BIsDelete;
        else if (Action == 'BIsReport')
          this.LocalResourceAccessUser[index].BIsReport = !this.LocalResourceAccessUser[index].BIsReport;
      }
    },
    // ذخیره لیست سطوح دسترسی کاربر در سرور
    async SaveEditResourceAccessUser() {
      // اعلام اتصال به سرور
      this.checkConnectToServer = true;

      let token = await this.$store.getters.getUserData.token;
      // ثبت لیست سطوح دسترسی کاربر در سرور
      await this.$store.dispatch("SaveTbResourceAccessToServer", {
        ResourceAccess: this.LocalResourceAccessUser,
        token: token,
      });

      // اعلام اتمام اتصال به سرور
      this.checkConnectToServer = false;

      // بستن مودال مدیریت سطوح دسترسی کاربر
      $("#ModalManageAccessUser").modal("hide");
      // اعلام اعمال تغییرات به والد
      // this.$emit("AddNewBaseAcc");
    }
  },
  watch: {
    ResourceAccessUser: function (value) {
      this.LocalResourceAccessUser = value;
    }
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListUserInfo/Components/ManageAccessUser.vue